import { ERROR_MESSAGES_DA, getCleUserMessage } from "@/api/cle-api/errors";
import { Notification, type Toaster } from "rsuite";

export const showCleApiErrorToast = (
  toaster: Toaster,
  error: unknown,
  fallback = ERROR_MESSAGES_DA.INTERNAL_ERROR,
): void => {
  const message = getCleUserMessage(error, fallback);
  console.log("message", message, error);
  toaster.push(
    <Notification type="error" header="Fejl">
      {message}
    </Notification>,
    { placement: "topEnd", duration: 5000 },
  );
};
